import axios from "axios";
import config from "../../config";

const instance = axios.create({
baseURL: config.apiBaseUrl,
  withCredentials: false,
});

instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      console.log("✅ TOKEN SENT:", token.substring(0, 30) + "...");
    } else {
      console.log("❌ NO TOKEN FOUND IN LOCALSTORAGE");
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default instance;